/*function encodeHTML(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
}
var ESC_MAP = {
	    '&': '&',
	    //'<': '',
	    //'>': '',
	   // "/":'',
	    //'\\':'',
	    //'&amp;':'',
	    //'&lt;':'',
	    //'&gt;':'',
	    //'"': '&quot;',
	    //"'": '&#39;',
	    "%":'%'
	    "javascript":'',
	    "alert":'',
	    ".js":'',
	    ".vbs":'',
	    "src":'',
	    "xss":'',
	    "&":'',
	    ".css":'',
	    "@import":'',
	    ".htc":'',
	    "document":'',
	    "cookie":'',
	    "image":'',
	    "url":'',
	    "object":'',
	    "embed":'',
	    "eval":'',
	    "cmd":'',
	    "redirect":'',
	    "meta":'',
	    "set-cookie":'',
	    "http-equiv":'',
	    "document":'',
	    "http":'',
	    "href":'',
	    "iframe":'',
	    "insert":'',
	    "update":'',
	    "delete":'',
	    "truncate":'',
	    "alter":'',
	    "create":''
	};

	function escapeHTML(s, forAttribute) {
		 s = s.toLowerCase();
		 
	    return s.replace(forAttribute ? /[&<>'"]/g : /[&<>]/g, function(c) {
	        return ESC_MAP[c];
	    });
	    
	   
	}
	
	 function getXSSResult(txtToValidate)
		{
			 txtToValidate= escapeHTML(txtToValidate,true);
			 txtToValidate = txtToValidate.toLowerCase();
			// txtToValidate = txtToValidate.replace(/(script|javascript|alert|.js|.vbs|src|xss|vbscript|&|.css|@import|.htc|document|cookie|image|url|expression|object|embed|eval|datasrc|exec|cmd|echo|redirect|meta|set-cookie|http-equiv|document|http|href|param|iframe|html|htm|insert|update|delete|drop|truncate|alter|create|)/g, "");
			// console.log("text from getXSSResult :::::::::::::" + txtToValidate);
			 return txtToValidate;
		}*/
	
	 
	 //export function checkXSSValidation(txtToValidate){
	 export function checkXSSValidation(txtToValidate){
		 return checkXSSValidationInner(txtToValidate);
	 }
	 
	 function  checkXSSValidationInner(txtToValidate) {
	     var replaceText ;
	      //eslint-disable-next-line
	     replaceText=txtToValidate.toString().replace('text/xscriptlet','').toString().replace('javascript:','').toString().replace('http:','').toString().replace('https:','').toString().replace('iframe',''); 
	     replaceText=encodeURI(replaceText);
	     replaceText=replaceText.toString().replace("%25","%");
	     return replaceText;
	  }

	 
	
	


// WEBPACK FOOTER //
// ./src/components/utils/CrossSiteValidation.js